"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RED = exports.ORANGE = exports.LIGHT_GREY = exports.LIGHT_GREEN = exports.LIGHT_BLUE = exports.GREY = exports.GREEN = exports.GOLD = exports.BLUE = void 0;
var GOLD = exports.GOLD = '#F4D316';
var ORANGE = exports.ORANGE = '#FF9900';
var RED = exports.RED = '#E53935';
var GREEN = exports.GREEN = '#47B04B';
var LIGHT_GREY = exports.LIGHT_GREY = '#C5C8CC';
var GREY = exports.GREY = '#777777';
var BLUE = exports.BLUE = '#4571BA';
var LIGHT_GREEN = exports.LIGHT_GREEN = '#99D29B';
var LIGHT_BLUE = exports.LIGHT_BLUE = '#ABC0E0';